<template>
  <div class="main-user">

    <main>
      <header>
        <h3>用户管理</h3>
        <!-- <span>/ computer management</span> -->
        <div class="btn-group">
          <a-button v-if="$IA('system:user:save')" type="primary" icon="plus" @click="handleOpen('添加用户')"
          >添加</a-button
          >
        </div>
      </header>
      <!-- 表格搜索栏 -->
      <div class="toolbar">
        <a-form-model :model="pagination" ref="searchBar" :layout="formLayout">
          <a-form-model-item prop="searchText" >
            <a-input-search placeholder="用户名/邮箱" style="width: 200px;" :loading="btnLoad"
                            allowClear v-model.trim="pagination.searchText" @input="searchTextChange" />
          </a-form-model-item>
          <a-form-model-item prop="orgId">
            <a-tree-select
                v-model='pagination.orgId'
                allowClear
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                :tree-data="treeData"
                style="width: 180px;"
                @change="searchChange"
                placeholder="选择部门"
                show-search
                :filterTreeNode="filter_tree_node"
                tree-default-expand-all
                :replaceFields="{ title: 'name', key: 'id',value:'id' }"
            >
            </a-tree-select>
          </a-form-model-item>
          <a-form-model-item prop="locked">
            <a-select
                v-model="pagination.locked"
                placeholder="状态"
                style="width: 180px;"
                :loading="btnLoad"
                allowClear
                @change="searchChange"
            >
              <a-select-option :value="0">未锁定</a-select-option>
              <a-select-option :value="1">已锁定</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item >
            <a-button  @click="resetSearch">重 置</a-button>
          </a-form-model-item>
        </a-form-model>


      </div>
      <!-- 数据表格 -->
      <a-table :columns="tableColumns" bordered :loading="tableLoad" :data-source="tableData" :pagination="queryCondition"  :scroll="{ y: 560 }"  @change="handleTableChange">
        <span slot="customTitle">用户名</span>

        <template slot="locked" slot-scope="text">
          <span v-if="text === 0"><a-tag color="green">未锁定</a-tag></span>
          <span v-else><a-tag color="orange">已锁定</a-tag></span>
        </template>
        <span slot="action" slot-scope="text, record" class="table-action-box">
             <a-tooltip  content="" v-if="$IA('system:user:update')" title="修改" placement="top" effect="light">
              <i class="table-edit" @click="handleOpen('修改', record)" ></i>
            </a-tooltip>
            <a-tooltip  content="" v-if="$IA('system:user:delete')&&record.userName!=='admin'" placement="top" effect="light">
              <i class="table-delected" @click="handleOpen('删除', record)" ></i>
            </a-tooltip>
             <a-tooltip  content="" v-if="$IA('system:user:grant')&&record.userName!=='admin'" title="关联角色" placement="top" effect="light">
              <i class="table-relatedRoles" @click="relationOpen('关联角色', record)" ></i>
            </a-tooltip>

        </span>
      </a-table>
    </main>

    <!-- 添加 -->
    <a-modal
      centered
      :title="modalTitle"
      :visible="modalVisible"
      :confirm-loading="submitLoad"
      @ok="handleOk"
      width="630px"
      @cancel="resetForm"
      :maskClosable="false"
      :width="modalTitle == '删除' ? '420px' : '630px'"
    >
      <a-form-model
        v-if="['添加用户', '修改'].includes(modalTitle)"
        :rules="userRules"
        :model="userForm"
        ref="userForm"
      >
        <a-form-model-item  prop="id" v-show="false">
          <a-input v-model="userForm.id" placeholder="请输入" />
        </a-form-model-item>
        <a-row :gutter="23">
          <a-col :span="12">
            <a-form-model-item label="用户名" prop="userName">
              <a-input :disabled="modalTitle=='修改'" v-model.trim="userForm.userName" placeholder="请输入" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="密码" prop="password">
              <a-input-password v-model="userForm.password" @input="inputChange" placeholder="请输入" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="部门" prop="orgId">
              <a-tree-select
                v-model='userForm.orgId'
                allowClear
                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                :tree-data="treeData"
                placeholder="选择部门"
                tree-default-expand-all
                show-search
                :filterTreeNode="filter_tree_node"
                :replaceFields="{ title: 'name', key: 'id',value:'id' }"
              >
              </a-tree-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="昵称" prop="nickName">
              <a-input v-model="userForm.nickName" placeholder="请输入" />
            </a-form-model-item>
          </a-col>



          <a-col :span="12">
            <a-form-model-item label="邮箱" prop="email">
              <a-input v-model="userForm.email" placeholder="请输入" />
            </a-form-model-item>
          </a-col>

          <a-col :span="12">
            <a-form-model-item label="状态" prop="locked">
              <a-select v-model="userForm.locked" placeholder="请选择">
                <a-select-option :value="0">未锁定</a-select-option>
                <a-select-option :value="1">已锁定 </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>

        </a-row>
        <template slot="footer">
          <a-button key="back" @click="modalVisible = false"> 取消 </a-button>
          <a-button key="submit" type="primary" @click="handleOk"> 提交 </a-button>
        </template>
      </a-form-model>



        <div class="deleteBox" v-if="modalTitle == '删除'">
          <a-icon type="exclamation-circle" theme="filled" />
          <p>此操作将永久删除该用户,是否继续?</p>
        </div>
    </a-modal>

    <!-- 关联角色 -->
    <a-modal
      centered
      title="关联角色"
      :visible="relationUserVisible"
      width="600px"
      @ok="robotSubmit"
      @cancel="relationUserVisible=false"
      :confirmLoading="submitLoad"
      :afterClose="emptyTransfer"
      :maskClosable="false"
    >
      <a-transfer
        :dataSource="mockData"
        showSearch
        :filterOption="filterOption"
        :targetKeys="targetKeys"
        @change="handleChange"
        @search="handleSearch"
        @selectChange="handleSelectChange"
        :selected-keys="selectedKeys"
        :render="item=>item.title"
        ref="transfer"
        :list-style="{
          width: '260px',
          height: '300px',
        }"
        :titles="['未选', '已选']"
      />

    </a-modal>
  </div>
</template>

<script>
import { validateNewPass } from "@/utils/validate.js";
import {notification} from "ant-design-vue";
export default {
  data() {
    return {
      tableLoad:false,
      btnLoad: false,
      pagination: {
        searchText: "",
        orgId: undefined,
        locked: undefined,
        pageSize: 10,
        pageNo: 1,
        current: 1,
        total: 0,
        showQuickJumper: true,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showTotal: (total, range) => `显示 ${range[0]} 到 ${range[1]} ，共 ${total} 条记录  `
      },
      formLayout:"inline",
      queryCondition: {},
      tableColumns: [
        {
          title: "序号",
          dataIndex: "index",
          key: "index",
          align: "center",
          width: 65,
          customRender: (text, record, index) => `${index + 1}`,
        },
        {
          width: 120,
          dataIndex: "userName",
          key: "userName",
          slots: { title: "customTitle" },
          scopedSlots: { customRender: "userName" },
          ellipsis: true,
        },
        {
          title: "部门",
          dataIndex: "orgName",
          key: "orgName",
        },
        {
          title: "昵称",
          dataIndex: "nickName",
          key: "nickName",
          ellipsis: true,
        },
        {
          title: "邮箱",
          dataIndex: "email",
          key: "email",
          ellipsis: true,
        },
        {
          title: "状态",
          dataIndex: "locked",
          scopedSlots: { customRender: "locked" },
          key: "locked",
          width: 80,
          align: 'center'
        },
        {
          title: "创建时间",
          dataIndex: "createTime",
          key: "createTime",
          ellipsis: true,
        },
        {
          title: "更新时间",
          dataIndex: "updateTime",
          key: "updateTime",
          ellipsis: true,
        },
        {
          title: "操作",
          key: "action",
          scopedSlots: { customRender: "action" },
          align: "center",
          width: 120,
        },
      ],
      // 添加/删除api
      saveApi:"",
      tableData: [],
      // 模态框显隐
      modalVisible: false,
      // 模态框标题
      modalTitle: "",
      // 单条数据
      singleDta:"",
      //部门下拉框
      treeData:[],
      // 添加表单
      userForm: {
        id:"",
        userName: "",
        password: "",
        nickName: "",
        locked: 0,
        orgId: undefined,
        email: "",
      },
      userRules: {
        userName: [{ required: true, max: 20, message: "账户最长不能超过20字符且不可为空" }],
        password: [
          { required: true, message: "密码不能为空" },
          { validator: validateNewPass, trigger: "blur" },
        ],
        nickName: [{ required: true, max: 20, message: "昵称最长不能超过20字符且不可为空" }],
        email: [
          { required: true, message: "邮箱不能为空" },
        {
          pattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
          message: "邮箱格式不正确",
        },
        {max: 250, message: '最长不能超过250字符'}

        ],
        orgId: [{ required: true, message: "部门不能为空" }],
        locked: [{ required: true, message: "状态不能为空" }],
      },
      // 关联角色
      relationUserVisible:false,
      mockData:[],
      targetKeys:[],
      relationForm:{
        roleIds:[], // 机器人id
        userId:"", // 环境id
      },
      environmentData:[],
      // 监听获取
      selectedKeys:[],
      // 是否按钮loading
      submitLoad: false,
      // 分页参数
      pagCurrent:{},
    };
  },
  methods: {
    // 部门筛选
    filter_tree_node( input,node ) {
         if ( node.children == null ) {
              if ( node.componentOptions.propsData.title.indexOf( input ) !=-1 ) {
                return true;
               } else {
                return false;
              }
         }
     },
    // 开启搜索
    filterOrgOption(input, option) {
      return (
          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    // 重置表单通用方法
    resetForm() {
      if ( this.modalTitle =='添加用户' || this.modalTitle =='修改' ) {
          this.$refs.userForm.resetFields()
      }
      this.modalVisible = false
    },
    // 重置搜索
    resetSearch(){
      this.$refs.searchBar.resetFields()
      this.searchChange()
    },
    // 重置穿梭框方法
    emptyTransfer(){
      const tr = this.$refs.transfer
      if(tr){
        //左侧搜索框 0
        tr.$children['0'].$children['0']._data.filterValue=''
        //右侧搜索框 2
        tr.$children['0'].$children['2']._data.filterValue=''
      }
      this.selectedKeys = []
    },
    inputChange(val){
      if (this.modalTitle =='修改'){
        if (val.data){
          this.userRules.password =[
            { required: false, message: "密码不能为空" },
            { validator: validateNewPass, trigger: "blur" },
          ]
        }else{
          this.userRules.password =[
            { required: false, message: "密码不能为空" },
          ]
        }
      }
    },
    // 打开模态框
    handleOpen(title,data) {
      this.modalTitle = title;
      this.modalVisible = true;
      this.$nextTick(()=>{
        this.singleDta = data
        switch (title) {
          case "添加用户":
            this.saveApi= '/user/save'
            // this.userForm.orgId = this.$store.state.user.userInfo.orgId
            this.userRules.password =[
              { required: true, message: "密码不能为空" },
              { validator: validateNewPass, trigger: "blur" },
            ]
            break;
          case "修改":
            this.saveApi = '/user/update'
            this.userForm = this.$lodash.pick(
              this.singleDta,
              this.$lodash.keys(this.userForm)
            );
            this.userRules.password =[
              { required: false, message: "密码不能为空" },
            ]

            break;
          case "删除":
            break;
        }
      })
    },
    // 确认模态框
    handleOk() {
    if (this.modalTitle== '添加用户' || this.modalTitle== '修改') {
        this.$refs.userForm.validate((valid) => {
        if (valid) {
            this.submitLoad = true;
            let saveData = this.$lodash.cloneDeep(this.userForm);
            saveData.password = saveData.password ?  saveData.password.trim() : null
            saveData.password = saveData.password ? this.$encrypt.encrypt(saveData.password):null
            this.axios
              .post(this.saveApi, saveData)
              .then((res) => {
                this.submitLoad = false;
                if (res.code === 200) {
                  notification.success({
                    message: res.message,
                    duration: 3,
                    customClass: "batch-import",
                  })
                  this.handleTableChange(this.modalTitle == "添加用户"? this.pagination:this.pagCurrent);
                  this.resetForm()
                }
              })
              .catch((err) => {
                this.submitLoad = false;
                console.log(err);
              });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }else{
          this.submitLoad = true;
          this.axios
            .delete("/user/delete/" + this.singleDta.id)
            .then((res) => {
              this.submitLoad = false;
              if (res.code === 200) {
                notification.success({
                  message: res.message,
                  duration: 3,
                  customClass: "batch-import",
                })
                this.handleTableChange(this.pagCurrent);
                this.modalVisible = false;
              }
            })
            .catch((err) => {
              this.submitLoad = false;
              console.log(err);
            });
    }
    },
    // 打开关联角色模态框
    relationOpen(title,data){
       this.relationUserVisible = true
       const targetKeys = [];
       const mockData = [];
       this.environmentData = data
       this.axios
        .post("/user/findUserRoles/" + data.id)
        .then((res) => {
          if (res.code === 200) {
            for (let i of res.data) {
              let data = {
                key: i.id.toString(),
                title: i.name,
                chosen: i.chosen,
                disabled:i.hasCheckPermission
              };
            if (data.chosen) {
              targetKeys.push(data.key);
            }
              mockData.push(data);
            }
            this.mockData = mockData
            this.targetKeys = targetKeys
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 搜索
    filterOption(inputValue, option) {
      return option.title.indexOf(inputValue) > -1;
    },
    handleChange(targetKeys, direction, moveKeys) {
      this.relationForm.roleIds = targetKeys
      this.targetKeys = targetKeys
    },
    handleSearch (dir, value) {
      console.log('search:', dir, value);
    },
    // 关联角色提交
     robotSubmit() {
      this.submitLoad = true;
      this.relationForm.roleIds = typeof this.relationForm.roleIds === 'string' ? '': this.relationForm.roleIds.join(",") ;
      this.relationForm.userId = this.environmentData.id
      this.axios
        .post('/user/grant', this.relationForm)
        .then((res) => {
          this.submitLoad = false;
          if (res.code === 200) {
            this.relationUserVisible = false;
            notification.success({
              message: res.message,
              duration: 3,
              customClass: "batch-import",
            })
            this.handleTableChange(this.pagCurrent);
          }
        })
        .catch((err) => {
          this.submitLoad = false;
          console.log(err);
        });
    },
    // 监听已选中-清空
    handleSelectChange(sourceSelectedKeys, targetSelectedKeys) {
       this.selectedKeys = [...sourceSelectedKeys, ...targetSelectedKeys];
    },
    // 部门下拉框
    allorgList() {
      this.axios
        .post("/org/findOrg",'')
        .then((res) => {
          if (res.code === 200) {
            this.treeData = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
      // 监听搜索输入框输入
     searchTextChange(val){
      if (window.searchTimer) {
        clearTimeout(searchTimer);
      }
      window.searchTimer = setTimeout(() => {
        this.searchChange(val)
      }, 1200);
    },
    // 搜索
    searchChange(v) {
      this.queryCondition = this.$lodash.cloneDeep(this.pagination)
      this.tableAjax()
    },
    // 监听翻页
    handleTableChange(pagination, filters, sorter) {
      this.queryCondition.pageNo =  pagination.current ? pagination.current : 1
      this.queryCondition.current =  pagination.current ? pagination.current : 1
      this.queryCondition.pageSize = pagination.pageSize ? pagination.pageSize : 10
      this.pagCurrent = pagination ? pagination:this.pagination
      this.tableAjax()
    },
    // 翻页请求
    tableAjax(){
      this.tableLoad = true;
      this.axios
        .post("/user/findPage", this.$qs.stringify(this.queryCondition))
        .then((res) => {
          this.tableLoad = false;
          if (res.code === 200) {
           this.tableData = res.data.records;
           this.queryCondition.total = res.data.total;
          }
        })
        .catch((err) => {
          console.log(err);
          this.tableLoad = false;
        });
    },
  },
  beforeMount(){
    this.searchChange()
    this.allorgList()
  }
};
</script>

<style lang="scss" scoped>
.main-user {

  main {
    margin: 16px;
    background-color: #fff;
    border-radius: 2px;

    header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px;
      border-bottom: 1px solid #f0f0f0;

      h3 {
        margin-bottom: 0;
        height: 18px;
        line-height:17px;
        padding-left: 12px;
        border-left: 4px solid #3373F2;
        font-size: 16px;
        font-weight: bold;
        color: #3d4966;
      }

      span {
        line-height: 16px;
        margin-left: 10px;
        color: #808080;
      }
    }
    .toolbar {
      display: flex;
      justify-content: space-between;
      padding: 16px;

      .search-bar {
        flex: 1;
      }
      .ant-form{
        .ant-form-item{
          margin-right: 16px;
        }
        .ant-form-item:last-child{
          .ant-btn{
            width: 74px;
            position: absolute;

          }
        }
      }
    }
    .ant-table-wrapper{
      padding: 0 16px 16px;
    }

    .ant-tag {
      border-radius: 16px;
    }

  }
}
  ::v-deep .ant-form-item .ant-form-item-label {
    font-weight: 600;
  }
  ::v-deep .ant-col-12{
    height: 104px;
  }
</style>
